(function () {
  function initFooterAccordion() {
    const isMobile = () => window.innerWidth <= 768;

    const menus = document.querySelectorAll(".footer__menu");

    menus.forEach(function (menu) {
      const heading = menu.querySelector(".footer__heading");
      if (!heading) return;

      heading.addEventListener("click", function () {
        if (!isMobile()) return;
        menu.classList.toggle("is-open");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFooterAccordion);
  } else {
    initFooterAccordion();
  }
})();
